import {toAbsoluteUrl} from '_metronic/helpers'
import {Dispatch, FC, SetStateAction} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'

type Props = {
  searchTerm: string
  setSearchTerm: Dispatch<SetStateAction<string>>
  width?: string
}

const Searchbar: FC<Props> = ({searchTerm, setSearchTerm, width}) => {
  const location = useLocation();
  const navigate = useNavigate()
  return (
    <div
      className='h-100 d-flex align-items-center position-relative'
      style={{
        width: `${width ? width : '250px'}`,
      }}
    >
      <img
        alt='search-icon'
        src={toAbsoluteUrl('/media/icon/search.svg')}
        className='position-absolute ms-4'
        style={{height: '18px', width: '18px'}}
      />
      {/* <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' /> */}
      <input
        type='text'
        data-kt-user-table-filter='search'
        autoComplete='off'
        placeholder={'Search...'}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className='form-control ps-12 w-100 text-dark'
        style={{height: '42px'}}
      />
      {searchTerm && (
        <button
          className='btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-2 p-1'
          onClick={() => {
            setSearchTerm('')
            navigate(location.pathname, {replace: true})
          }}
          style={{
            background: 'transparent',
            transition: 'all 0.2s ease',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '4px',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#f8f9fa'
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent'
          }}
        >
          <i className='bi bi-x fs-2 text-dark'></i>
        </button>
      )}
    </div>
  )
}

export default Searchbar
